module.exports = __webpack_public_path__ + "c09e24a1cb35935614adb84233b2fb59.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/OurTeam/tomas-krupka.jpg
// module id = 271
// module chunks = 0